import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Reveal } from 'react-genie'
import { customMedia } from '../../common/customMedia'
import { Image } from '../../common/Image'
import { useTranslation, Trans } from 'react-i18next'

const JpVideo = require('../../../videos/Remohab_JP.mp4')
const EnVideo = require('../../../videos/Remohab_EN.mp4')

export const RemohabImage = () => {
  const [features, setFeatures] = useState([])

  const [t, i18n] = useTranslation()
  const videoRef = useRef<HTMLVideoElement>()

  useEffect(() => {
    setFeatures([
      {
        imagePath: 'remohab_image_1@2x.png',
        title: 'feature1Title',
        detail: 'feature1Detail'
      },
      {
        imagePath: 'remohab_image_2@2x.png',
        title: 'feature2Title',
        detail: 'feature2Detail'
      },
      {
        imagePath: 'remohab_image_3@2x.png',
        title: 'feature3Title',
        detail: 'feature3Detail'
      }
    ])
  }, [])

  useEffect(() => {
    videoRef.current.src =
      i18n.language === 'ja' ? JpVideo + '#t=2' : EnVideo + '#t=2'
  }, [i18n.language])

  return (
    <>
      <Container>
        <Wrapper>
          <Reveal delay={500}>
            <RemohabImageWrapper>
              <Image path="remohab_image@2x.png" />
            </RemohabImageWrapper>
          </Reveal>

          <Reveal delay={500}>
            <VideoWrapper>
              <video ref={videoRef} controls>
                <source src={JpVideo + '#t=2'} type="video/mp4" />
              </video>
            </VideoWrapper>
          </Reveal>

          {features.map((f, i) => (
            <Reveal delay={500} key={i}>
              <FeatureWrapper>
                <FeatureImageWrapper>
                  <Image path={f.imagePath} />
                </FeatureImageWrapper>
                <FeatureContentWrapper>
                  <FeatureTitle>{t(f.title)}</FeatureTitle>
                  <FeatureDetail>{t(f.detail)}</FeatureDetail>
                </FeatureContentWrapper>
              </FeatureWrapper>
            </Reveal>
          ))}
        </Wrapper>
      </Container>
    </>
  )
}

const Container = styled.div`
  ${customMedia.lessThan('large')`
    padding: 40px 20px;
  `}
  ${customMedia.greaterThan('large')`
    padding: 75px 0 85px;
  `}
`

const Wrapper = styled.div`
  ${customMedia.greaterThan('medium')`
  `}
  ${customMedia.between('medium', 'large')`
    margin: 0 auto;
    width: 735px;
  `}
  ${customMedia.greaterThan('large')`
    margin: 0 auto;
    width: 1000px;
  `}
`

const RemohabImageWrapper = styled.div`
  ${customMedia.lessThan('medium')`
    margin: 0 auto 40px;
    width: 150px;
  `}
  ${customMedia.greaterThan('medium')`
    margin: 0 auto 50px;
    width: 300px;
  `}
`

const VideoWrapper = styled.div`
  ${customMedia.lessThan('medium')`
    margin: 22px 0;
  `}
  ${customMedia.greaterThan('medium')`
    margin: 80px 0;
  `}

  video {
    ${customMedia.lessThan('small')`
      height: 188px;
      margin: 0 auto;
      padding: 0 20px;
      width: 100%;
    `}
    ${customMedia.between('small', 'medium')`
      height: 188px;
      margin: 0 auto;
      width: 335px;
    `}
    ${customMedia.between('medium', 'large')`
      height: 281px;
      margin: 0 auto;
      width: 500px;
    `}
    ${customMedia.greaterThan('large')`
      height: 562px;
      margin: 0 auto;
      width: 1000px;
    `}

    :focus {
      outline:0;
    }
  }
  text-align: center;
`

const FeatureWrapper = styled.div`
  ${customMedia.lessThan('large')`
    margin-top: 35px;
  `}
  ${customMedia.greaterThan('large')`
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    margin-bottom: 60px;
  `}
`

const FeatureImageWrapper = styled.div`
  ${customMedia.lessThan('medium')`
    margin: 12px auto;
    width: 55px;
  `}
  ${customMedia.between('medium', 'large')`
    margin: 12px auto;
    width: 100px;
  `}
  ${customMedia.greaterThan('large')`
    width: 100px;
  `}
  
  flex: none;
`

const FeatureContentWrapper = styled.div`
  ${customMedia.lessThan('large')`
  `}
  ${customMedia.greaterThan('large')`
    margin-left: 50px;
  `}
`

const FeatureTitle = styled.h1`
  ${customMedia.lessThan('medium')`
    font-size: 1.5rem;
    margin: 12px 0;
    text-align: center;
  `}
  ${customMedia.greaterThan('medium')`
    font-size: 3rem;
    margin-bottom: 28px;
  `}

  color: #26d2ad;
  font-weight: bold;
`
const FeatureDetail = styled.h2`
  ${customMedia.lessThan('medium')`
    font-size: 1.2rem;
  `}
  ${customMedia.greaterThan('medium')`
    font-size: 1.8rem;
  `}

  color: #60656b;
`
